import { render, staticRenderFns } from "./LbaTabs.vue?vue&type=template&id=3b7ce894"
import script from "./LbaTabs.js?vue&type=script&lang=js&external"
export * from "./LbaTabs.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports